import getIvKeyValue from './getIvKeyValue';

/**
 * Gets the device from iv parameter and stores it in hcStorage.
 *
 * @param {String} iv iv parameter from campaing URL.
 * @param {Object} hcStorage HC storage object
 */
function getDeviceFromIv(iv, hcStorage) {
  const ivDevice = getIvKeyValue(iv, 'd').toLowerCase();
  const deviceMap = {
    m: 'Mobile',
    p: 'Mobile',
    t: 'Tablet',
    c: 'Desktop',
    tablet: 'Tablet',
    mobile: 'Mobile',
    computer: 'Desktop',
    desktop: 'Desktop',
  };

  if (deviceMap[ivDevice]) {
    hcStorage.Device = deviceMap[ivDevice];
  } else {
    delete hcStorage.Device;
  }
}

export default getDeviceFromIv;
